import React from "react";

import MainNavbar from "./components/MainNavbar";
import HamburgerMenu from "./components/HamburgerMenu";

import classes from "./index.module.css";
import LanguageDropdown from "./components/LanguageDropdown";

const Navbar = () => {
  return (
    <div className={classes["header-wrapper"]}>
      <MainNavbar />
      <LanguageDropdown />
      <HamburgerMenu />
    </div>
  );
};

export default Navbar;
